<template>
  <SimpleModuleDashboard
    :module-id="Modules.FLUJO_VENTAS"
    :profile-id="Profiles.PERSONAL"
    include-php-custom
    :actions="dashboardActions"
  />
</template>

<script>
import Profiles from '@/config/profiles'
import Modules from '@/config/modules'
import Param from '@/config/parameters'
import Helper from '@/handler/helper'
import SimpleModuleDashboard from '@/components/inc/dashboard/SimpleModuleDashboard'

export default {
  components: { SimpleModuleDashboard },
  data: () => ({
    Modules,
    Profiles,
    haveContract: Helper.hasParametersAccess(Param.P16),
    useViewCRM: Helper.hasParametersAccess(Param.P64),
  }),
  computed: {
    isSeller() {
      return !!Helper.getSeller()
    },
    dashboardActions() {
      if(this.isSeller) {
        return [{ id: 'crudLeadsSellers', reference: 'crudLeadsSellers', route: 'SalesFlowStaffCrudLeadsSellers', tone: 'primary' }]
      }
      const actions = [
        this.useViewCRM
          ? { id: 'crudLeadsServices', reference: 'crudLeadsServices', route: 'SalesFlowStaffCrudLeadsServices', tone: 'primary' }
          : { id: 'crudLeads', reference: 'crudLeads', route: 'SalesFlowStaffCrudLeads', tone: 'primary' },
        { id: 'crudCategories', reference: 'crudCategories', route: 'SalesFlowStaffCrudCategories', tone: 'secondary', group: 'Configuraciones' },
        { id: 'crudSource', reference: 'crudSource', route: 'SalesFlowStaffCrudSource', tone: 'success', group: 'Configuraciones' },
        { id: 'crudLostMotive', reference: 'crudLostMotive', route: 'SalesFlowStaffCrudLostMotive', tone: 'warning', group: 'Configuraciones' },
      ]
      if(this.haveContract) actions.push({ id: 'crudContract', reference: 'crudContract', route: 'SalesFlowStaffCrudContract', tone: 'primary' })
      return actions
    },
  },
}
</script>
